/** Режим шторки задаёт её высоту и жесты - см. getSwipeModalGestures. */
export enum ESwipeModalMode {
  /** Половина экрана: свайп вверх раскрывает на весь, свайп вниз закрывает (листинг) */
  HALF = 'half',
  /** Весь экран: свайпы не работают, закрытие только крестиком (раскрытый листинг) */
  FULL = 'full',
  /** Высота по содержимому: свайп вниз закрывает, вверх ничего (превью объявления) */
  CONTENT = 'content',
}

export interface ISwipeModalGestures {
  /** Свайп вниз закрывает шторку */
  closeOnSwipeDown: boolean;
  /** Свайп вверх раскрывает шторку на весь экран */
  expandOnSwipeUp: boolean;
}
